var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.05,
    height: 15.843,
    viewBox: "0 0 18.05 15.843",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "cloud-download-outline",
    d: "M26.482,57.93H29.1c1.9,0,3.448-.731,3.448-2.607s-1.827-2.533-3.31-2.607A4.962,4.962,0,0,0,24.275,48a4.559,4.559,0,0,0-4.413,3.144c-2.069.2-3.862,1.237-3.862,3.393s1.862,3.393,4.137,3.393h1.931m0,2.21,2.207,2.2,2.207-2.2m-2.207-6.072v7.724",
    transform: "translate(-15.25 -47.25)",
    fill: "none",
    stroke: "#0d0d0d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudDownloadIcon);
export default __webpack_public_path__ + "static/media/cloud-download-icon.3dd86c61df0e28dd0d883cf361b982f4.svg";
export { ForwardRef as ReactComponent };